/*
 * File: form-textarea.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-26 01:34:46
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
} from "../../core/lib/core";
import { PropInnateSync } from "@root/core/vue-props";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
export default class FormTextarea extends BaseFormComponent {
    @PropInnateSync("value", { type: String, required: false })
    innateValue!: string | undefined;

    @Prop({ type: String, required: false })
    height?: string;

    /// private helpers
    // required validation for textarea
    @makeRequiredValidator({
        validator: (o) => !(o.value === "" || o.value == null),
    })
    defaultRequired() {
        return undefined;
    }
}
